export const FACILITY_GROUP_ACTION = {
  ADD: 1,
  REMOVE: 2,
  SET: 3,
  CLEAR: 4
};
